import {
  FETCH_DECREMENT_REQUESTED,
  FETCH_DECREMENT_SUCCEED,
  FETCH_INCREMENT_SUCCEED, FETCH_LOGIN_FAIL,
  FETCH_LOGIN_REQUESTED, FETCH_LOGIN_SUCCEED,
  LOGOUT
} from './actionTypes';
import { INCREMENT_REQUESTED } from '../../redux/auth/actionTypes';

const AuthErrors = {
  loginFailed: 'Не удалось авторизоваться. Проверьте email или пароль.'
}

export function fetchLoginRequested(params) {
  return {
    type: FETCH_LOGIN_REQUESTED,
    payload: params,
  };
}

export function fetchLoginSucceeded(params) {
  return {
    type: FETCH_LOGIN_SUCCEED,
    payload: params,
  };
}

export function fetchLoginFailed(params) {
  return {
    type: FETCH_LOGIN_FAIL,
    payload: params,
  };
}

export const login = (params) => {
  return {
    type: LOGOUT,
    payload: params,
  };
  // return (dispatch) => {
  //   dispatch({
  //     type: LOGIN_REQUESTED
  //   })
  //
  //   SarafanApiClient.login({ email, password })
  //     .then((response) => {
  //       if (response &&
  //         response.body &&
  //         response.body.is_successful &&
  //         response.body.data.user &&
  //         response.body.data.access_token)
  //       {
  //         dispatch({
  //           type: actionTypes.LOGIN_SUCCEED,
  //           user: response.body.data.user,
  //           access_token: response.body.data.access_token,
  //         })
  //         successCallback()
  //       } else {
  //         dispatch({
  //           type: actionTypes.LOGIN_FAIL
  //         })
  //         errorCallback(AuthErrors.loginFailed)
  //       }
  //
  //     })
  //     .catch((error) => {
  //       dispatch({
  //         type: actionTypes.LOGIN_FAIL
  //       })
  //       errorCallback(AuthErrors.loginFailed)
  //     })
  // }
}
export const logout = () => {
  return {
    type: LOGOUT,
  };
}

export const incrementRequested = () => {
  return {
    type: INCREMENT_REQUESTED,
  };
}

export const incrementSucceed = () => {
  return {
    type: FETCH_INCREMENT_SUCCEED,
  };
}

export const decrementRequested = () => {
  return {
    type: FETCH_DECREMENT_REQUESTED,
  };
}

export const decrementSucceed = () => {
  return {
    type: FETCH_DECREMENT_SUCCEED,
  };
}



// WEBPACK FOOTER //
// ./src/store/auth/actions.js